import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "GlobalBikeApplications" })
export default class GlobalBikeApplications extends Vue {
    public localizer: any = Localizer;
    public brandName: string = null;
    public modelTitle: any = null;
    public cCmTitle: any = null;
    public yearTitle: string = null;

    public isLoading: boolean = false;
    public isCompatibility: boolean = false;
    public applicationUrl: string = null;

    public isProductApplicationBrandsLoader: boolean = false;
    public isProductApplicationsLoader: boolean = false;
    public isProductApplicationList: boolean = false;

    public brandList: any[] = [];
    public modelList: any[] = [];
    public cCmList: any[] = [];
    public yearList: any[] = [];

    public selectedProductApplicationBrand: any = null;
    public productApplications: any[] = [];

    public pageCount: number = 0;
    public pageIndex: number = 0;

    @Prop() readonly bremboCode: string;
    @Prop() readonly marketType: string;

    @Watch("brandName") onBrandCodeChanged(value: any, oldValue: any) {
        if (!value) {
            this.modelList = [];
            this.brandName = null;
        } else if (value !== oldValue) {
            this.getModelList();
        }

        this.modelTitle = null;
        this.isCompatibility = false;
    }

    @Watch("modelTitle.title") onModelCodeChanged(value: any, oldValue: any) {
        if (!value) {
            this.cCmList = [];
            this.modelTitle = null;
        } else if (value !== oldValue) {
            this.getCCmList();
        }

        this.cCmTitle = null;
        this.isCompatibility = false;
    }

    @Watch("cCmTitle.title") onTypeCodeChanged(value: any, oldValue: any) {
        if (!value) {
            this.yearList = [];
            this.cCmTitle = null;
        } else if (value !== oldValue) {
            this.getYearList();
        }

        this.yearTitle = null;
        this.isCompatibility = false;
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.isLoading = true;
        await this.getBrandList();
        this.isLoading = false;

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('compatibility')) {
            (<any>this).$refs.globalBikeApplications.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }

    public async getBrandList() {
        let response = (await Axios.post(this.routes.CatalogueGlobalBikeList_GetProductApplicationBrands, { bremboCode: this.bremboCode })).data;

        if (response) {
            this.brandList = response;
        } else {
            this.brandList = [];
        }
    }

    public async getModelList() {
        this.modelList = [];
        let response = (await Axios.post(this.routes.CatalogueGlobalBikeList_GetProductApplicationModels, { bremboCode: this.bremboCode, brandName: this.brandName })).data;
        for (var item of response) {
            if (this.modelList.filter(x => x.title === item.title).length === 0) {
                this.modelList.push({ title: item.title, modelName: item.modelName, typeName: item.typeName });
            }
        }
    }

    public async getCCmList() {
        this.cCmList = [];
        let response = (await Axios.post(this.routes.CatalogueGlobalBikeList_GetProductApplicationModels, { bremboCode: this.bremboCode, brandName: this.brandName, modelName: this.modelTitle.modelName, typeName: this.modelTitle.typeName })).data;

        for (var item of response) {
            if (this.cCmList.filter(x => x.cCm === item.cCm).length === 0) {
                this.cCmList.push({ title: item.cCm.toString(), value: item.cCm, typeCode: item.typeCode });
            }
        }
    }

    public async getYearList() {
        this.yearList = [];
        let response = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_GetSearchYears, { typeCode: this.cCmTitle.typeCode })).data;
        this.yearList = response;
    }

    public async getIsCompatibility() {
        if (this.brandName != null && this.modelTitle.title != null && this.cCmTitle.title != null, this.yearTitle != null) {
            this.isCompatibility = true;
            GTagHelper.sendEvent("click", "compatibility", "check");
        } else {
            this.isCompatibility = false;
        }
    }

    public async showProductApplicationList() {
        if (!this.brandList || this.brandList.length === 0) {
            this.isProductApplicationBrandsLoader = true;

            await this.getBrandList();

            this.isProductApplicationBrandsLoader = false;
        }

        if (!this.selectedProductApplicationBrand) {
            this.selectedProductApplicationBrand = this.brandList[0];
            this.getProductApplications(this.selectedProductApplicationBrand.brandName, 1);
            GTagHelper.sendEvent("click", "compatibility", "open_list");
        }

        this.isProductApplicationList = true;
    }

    public async getProductApplications(brandName: string, page: number) {
        this.isProductApplicationsLoader = true;

        const response = (await Axios.post(this.routes.CatalogueGlobalBikeList_GetProductApplications, { bremboCode: this.bremboCode, brandName: brandName, page: page })).data;
        this.productApplications = response.applicationItems;
        this.pageCount = response.pageCount;
        this.pageIndex = response.pageIndex;

        this.isProductApplicationsLoader = false;
    }

    public async setPage(page: number) {
        await this.getProductApplications(this.selectedProductApplicationBrand.brandCode, page);
    }

    public setSelectedProductApplicationBrand(productApplicationBrand: any) {
        if (this.selectedProductApplicationBrand !== productApplicationBrand) {
            this.selectedProductApplicationBrand = productApplicationBrand;
            this.getProductApplications(this.selectedProductApplicationBrand.brandName, 1);
        }
    }

    public async searchApplication(productApplication: any) {
        const response = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_SearchType, { brandName: productApplication.brandName, modelName: productApplication.modelName, typeName: productApplication.typeName, cCm: productApplication.cCm, year: productApplication.yearStart, typeCode: productApplication.typeCode })).data;

        if (response) {
            GTagHelper.sendEvent("click", "compatibility", "application");
            window.location.href = response.url;
        }
    }

    public async searchProdutAppliction() {
        const response = (await Axios.post(this.routes.CatalogueGlobalBikeSearch_SearchType, { brandName: this.brandName, modelName: this.modelTitle.modelName, typeName: this.modelTitle.typeName, cCm: this.cCmTitle.value, year: this.yearTitle, typeCode: this.cCmTitle.typeCode })).data;

        if (response) {
            window.location.href = response.url;
        }
    }
}